import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icons/google-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Sign up", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "google-icon"
}, null, -1)
const _hoisted_3 = { class: "info-center min mb-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info-center min" }, [
  /*#__PURE__*/_createTextVNode(" By clicking Sign Up, I agree that the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.reply200.com/privacy-policy",
    target: "_blank"
  }, "Terms of Use and Privacy Notice"),
  /*#__PURE__*/_createTextVNode(" will govern the use of services I receive and personal data I provide respectively. ")
], -1)

import { reactive, ref, onMounted } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';
import { useErrors } from '@/utils/use-errors';
import { useTitle } from '@vueuse/core';
import { getLoginLink, getOrigin, hasLoginLink, isOrigin } from '@/utils/origin'
import { query } from '@/utils/api-utils';
import { getJwt } from '@/api';
import VAuthInput from '@/components/VAuthInput.vue';
import VButton from '@/components/VButton.vue'
import MailIcon from '@/components/icons/other/MailIcon.vue'
import LockIcon from '@/components/icons/other/LockIcon.vue'
import VDivider from '@/components/VDivider.vue'
import VReferalSuccessLabel from '../VReferalSuccessLabel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthRegisterForm',
  setup(__props) {

const values = reactive({ email: "", password: "" })
const { errors, checkRequired } = useErrors(values)

const accountStore = useAccountStore()
const router = useRouter()
const pending = ref(false)

const register = async (e: Event) => {
  e.preventDefault()
  if (!checkRequired([ "email", "password" ])) return
  pending.value = true
  try {
    await accountStore.register(values)
    router.push("/")
  } catch(e) {
    const body = (e as any).body
    if (Array.isArray(body) && body[0].field) {
      errors[body[0].field] = body[0].message
    }
    console.warn(e)
    pending.value = false
  }
}

const referal = ref("")
const referalPending = ref(false)
const referalStatus = ref("none")
const referalCount = ref(200)

const applyReferal = async () => {
  referalPending.value = true
  try {
    referalCount.value = await accountStore.validateReferal(referal.value)
    referalStatus.value = "success"
  } catch(e) {
    referalStatus.value = "error"
  } finally {
    referalPending.value = false
  }
}

onMounted(() => {
  const cachedReferal = window.localStorage.getItem("cachedReferals");
  if (cachedReferal) {
    referal.value = cachedReferal;
    applyReferal();
  }
});

useTitle("Sign up | Reply200")


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    class: "auth__form",
    onSubmit: register
  }, [
    _hoisted_1,
    _createVNode(VAuthInput, {
      icon: MailIcon,
      modelValue: values.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values.email) = $event)),
      error: _unref(errors).email,
      placeholder: "Your Email"
    }, null, 8, ["modelValue", "error"]),
    _createVNode(VAuthInput, {
      icon: LockIcon,
      modelValue: values.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.password) = $event)),
      error: _unref(errors).password,
      placeholder: "Password",
      type: "password"
    }, null, 8, ["modelValue", "error"]),
    _createVNode(VAuthInput, {
      modelValue: referal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((referal).value = $event)),
      placeholder: "Referral code"
    }, {
      append: _withCtx(() => [
        (referal.value.length > 0)
          ? (_openBlock(), _createBlock(VButton, {
              key: 0,
              disabled: referalPending.value,
              type: "button",
              class: "v-input-outlined__append-button",
              onClick: applyReferal
            }, {
              default: _withCtx(() => [
                _createTextVNode("Apply")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(VReferalSuccessLabel, {
      status: referalStatus.value,
      count: referalCount.value
    }, null, 8, ["status", "count"]),
    _createVNode(VButton, {
      class: "primary mb-3 mt-1",
      onClick: register,
      type: "submit",
      disabled: pending.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Sign up ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(VDivider, { class: "mb-3" }, {
      default: _withCtx(() => [
        _createTextVNode("or sign up with")
      ]),
      _: 1
    }),
    _createVNode(VButton, {
      class: "clear google mb-2",
      type: "button",
      onClick: _unref(accountStore).authByGoogle
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" Google ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode("Got an account? "),
      (_unref(hasLoginLink)())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _unref(getLoginLink)()
          }, "Log in here", 8, _hoisted_4))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: _unref(getLoginLink)()
          }, {
            default: _withCtx(() => [
              _createTextVNode("Log in here")
            ]),
            _: 1
          }, 8, ["to"]))
    ]),
    _hoisted_5
  ], 32))
}
}

})